import './offer.scss';
import Swiper from '../../vendor/swiper/swiper';
require('../../assets/images/kombi-tips-stoerer.svg');

class Offer {
    constructor ($element) {
        this.$offer = $element;
        this.$offerSlider = this.$offer.querySelector('[data-lot-offer-slider="slider"]');
        this.$sliderPagination = this.$offer.querySelector('[data-lot-offer-slider="pagination"]');

        this.slider = null;
    }

    init () {
        this.initSlider();
    }

    initSlider () {
        this.slider = new Swiper(this.$offerSlider, {
            initialSlide: 1,
            slidesPerView: 1,
            spaceBetween: 22,
            resistanceRatio: 0,
            threshold: 12,
            speed: 500,
            autoHeight: true,
            breakpointsInverse: true,
            observer: true,
            pagination: {
                el: this.$sliderPagination,
                clickable: true
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 22
                },
                1280: {
                    slidesPerView: 3,
                    spaceBetween: 22
                }
            }
        });
    }
}

export { Offer };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $lotOffer = $context.querySelectorAll('[data-lot-offer="root"]');

    if ($lotOffer.length > 0) {
        const lotOffer = [];
        $lotOffer.forEach(($offer, index) => {
            lotOffer[index] = new Offer($offer);
            lotOffer[index].init();
        });
    }
});
